






import { Component, Vue, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

import { i18n } from '@/main'

@Component
export default class App extends Vue {
  default: string = 'public'

  @Getter('locale', { namespace: 'user' }) locale

  get layout(): string {
    return `${this.$route.meta.layout || this.default}-layout`
  }

  @Watch('locale', { immediate: true })
  updatei18n(locale) {
    i18n.locale = this.locale
  }
}
